module.exports = __webpack_public_path__ + "img/cabinet_outline.28c88f48.svg";